var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedgers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_22387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5989 26.7891H18.5273V37.347H45.5989L45.5989 26.7891ZM26.7842 35.0459H20.8285V29.0902H26.7842V35.0459ZM31.6232 32.9817H29.7959V31.1543H31.6232V32.9817ZM35.2932 32.9817H33.4658V31.1543H35.2932V32.9817ZM38.9631 32.9817H37.1357V31.1543H38.9631V32.9817ZM42.633 32.9817H40.8056V31.1543H42.633V32.9817Z",
    fill: "#E86A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5273 18.5322H45.5989V20.8333H18.5273V18.5322Z",
    fill: "#E86A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6562 30.917H24.9573V33.218H22.6562V30.917Z",
    fill: "#E86A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7014 39.1743V22.6606H14.4004V41.4753H41.4719V39.1743H16.7014Z",
    fill: "#E86A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5273 22.6606H45.5989V24.9617H18.5273V22.6606Z",
    fill: "#E86A0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_22387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.2,
    height: 31.2,
    fill: "white",
    transform: "translate(14.4004 14.3999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgers);
export default __webpack_public_path__ + "static/media/ledgers.c42b89c5b40f3c2dfab39b10b4766230.svg";
export { ForwardRef as ReactComponent };